import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import Suggestion from 'main/stores/global_search/Suggestion';

class GlobalSearch extends DomainObject {
  queriedAt;

  _relations = {
    results: [Suggestion]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      queriedAt: observable
    });

    this.merge(other);
  }
}

export default GlobalSearch;
